import { render, staticRenderFns } from "./guidePage.vue?vue&type=template&id=531cdef6&scoped=true&"
import script from "./guidePage.vue?vue&type=script&lang=js&"
export * from "./guidePage.vue?vue&type=script&lang=js&"
import style0 from "./guidePage.vue?vue&type=style&index=0&id=531cdef6&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "531cdef6",
  null
  
)

export default component.exports